module.exports = __webpack_public_path__ + "static/media/objects.29de35f4.svg";